import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="text-sm text-muted-foreground" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5">
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1.5">
          {i < items.length - 1 ? (
            <>
              <Link to={it.path} className="hover:text-foreground hover:underline underline-offset-4">
                {it.name}
              </Link>
              <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
            </>
          ) : (
            <span aria-current="page" className="text-foreground">
              {it.name}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
